import {createSystem, defaultConfig} from '@chakra-ui/react'
import {buttonTheme} from './components/button'
import {containerTheme} from './components/container'
import {linkTheme} from './components/link'
import {menuTheme} from './components/menu'
import foundations from './foundations'
import styles from './styles'

type TokenTree = {[key: string]: {value: string} | TokenTree}
function tokens(values: Record<string, string | object>): TokenTree {
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => [
      key,
      typeof value === 'string'
        ? {value}
        : tokens(value as Record<string, string | object>),
    ]),
  )
}

// Chakra 3 uses semantic palettes, including the application's brand and legacy aliases.
const palettes = {
  blue: 'blue',
  gray: 'gray',
  neutral: 'neutral',
  orange: 'orange',
  red: 'red',
  slate: 'slate',
  brand: 'blue',
  facebook: 'blue',
  twitter: 'blue',
  telegram: 'blue',
  blackAlpha: 'gray',
}

export default createSystem(defaultConfig, {
  globalCss: styles,
  theme: {
    breakpoints: foundations.breakpoints,
    tokens: {
      colors: tokens(foundations.colors),
      spacing: tokens(foundations.space),
      sizes: tokens(foundations.sizes),
      fonts: tokens(foundations.fonts),
      shadows: {
        base: {
          value:
            '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        },
      },
    },
    semanticTokens: {
      colors: Object.fromEntries(
        Object.entries(palettes).map(([name, source]) => [
          name,
          {
            solid: {
              value:
                name === 'brand' ? '{colors.brand}' : `{colors.${source}.600}`,
            },
            contrast: {value: '{colors.white}'},
            fg: {value: `{colors.${source}.700}`},
            muted: {value: `{colors.${source}.100}`},
            subtle: {value: `{colors.${source}.50}`},
            emphasized: {value: `{colors.${source}.200}`},
            focusRing: {value: `{colors.${source}.500}`},
          },
        ]),
      ),
    },
    recipes: {button: buttonTheme, container: containerTheme, link: linkTheme},
    slotRecipes: {menu: menuTheme},
  },
})
